import { render, staticRenderFns } from "./EmployeeDetailsCardWages.vue?vue&type=template&id=081776c0&scoped=true&"
import script from "./EmployeeDetailsCardWages.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardWages.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailsCardWages.vue?vue&type=style&index=0&id=081776c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081776c0",
  null
  
)

export default component.exports